import React from "react";

import PrintFinanceBars from "../common/PrintFinanceBars";

import lbl from "../../../data/Labels.json";

const Chart = ({ data }) => {
  const budget = Number(data?.budget) || 0;
  const paid = Number(data?.paid) || 0;
  const balance = Number(data?.balance) || 0;
  const paidPercentage = budget > 0 ? (paid * 100) / budget : 0;

  const rows = [
    { label: lbl.Budget, value: budget, color: "#48C29D" },
    { label: lbl.Paid, value: paid, color: "#9A3859" },
    { label: "بیلانس", value: balance, color: "#EF9C0E" },
  ];

  return data ? (
    <div className="print-finance-chart-wrap">
      <PrintFinanceBars
        rows={rows}
        percentLabel={lbl.PaidPercentage}
        percent={paidPercentage}
      />
    </div>
  ) : null;
};

export default Chart;
